// local
import {
  PRESIDENT,
  TRENDS,
  PRES_COUNT_NATIONAL,
  US_PRES,
} from './constants.js';
// packages
import { createFeed } from './stores.js';
// import { topojsonToGeoJson } from './utils/geography.js';
import {
  renderSvelteComponent,
  findSvelteComponentContainer,
} from './utils/render.js';
import { derived } from 'svelte/store';

// components
import ElectoralCollege from './components/ElectoralCollege.svelte';
import NationalScoreboard from './components/NationalScoreboard.svelte';
import PresidentialView from './components/PresidentialView.svelte';
import BarChart from './components/BarChart.svelte';

/**
 * @type {Map<string, import('../types.jsjs').Crosswalk>}
 */
const crosswalk = window.CROSSWALK.assets.img;

//components

async function main() {
  // raw feed
  // for test ntl page
  const trendsFeed = await createFeed(TRENDS);
  const presTrends = derived(trendsFeed, ($feed) => $feed.president);
  const presFeed = await createFeed(PRESIDENT);
  const nationalFeed = await createFeed(US_PRES);

  // Presidential

  const electoral_trends = findSvelteComponentContainer('#balance-of-power');
  const map = findSvelteComponentContainer('#map');
  const scoreboard = findSvelteComponentContainer('#scoreboard');

  if (PRES_COUNT_NATIONAL == 2) {
    renderSvelteComponent(
      ElectoralCollege,
      /** @type {HTMLElement} */ electoral_trends,
      {
        feed: presTrends,
        crosswalk,
      }
    );
  } else {
    renderSvelteComponent(
      BarChart,
      /** @type {HTMLElement} */ electoral_trends,
      {
        race: nationalFeed,
        face: false,
        numOfCandidates: 3,
        electoral: true,
        // crosswalk,
      }
    );
  }
  // map tk here
  renderSvelteComponent(PresidentialView, /** @type {HTMLElement} */ map, {
    feed: presFeed,
  });

  // table
  renderSvelteComponent(
    NationalScoreboard,
    /** @type {HTMLElement} */ scoreboard,
    {
      feed: presFeed,
    }
  );
}

main().catch(console.error);
